import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemService from "../../../../services/customer_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import { getTodaysData } from "../../../../common/Validations";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import { getQtnJobList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { useDispatch, useSelector } from "react-redux";
const JobReivisonUpdate = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData /*setDropdownData*/] = useState("");
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const faliureRevisionUpdate = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFaliureRevisionUpdate] = useState(faliureRevisionUpdate);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);

  let documentNumber = useSelector(
    (state) => state?.customerV1?.quotation_Job?.quotation_JobNr
  ); // User Details from Store

  const [formInputs, setFormInputs] = useState({
    transactionDate: getTodaysData() || "",
    clientCompanyName: "",
    projectName: "",
    location: "",
    validUntil: "",
    estimationDate: getTodaysData() || "",
    salesOfficerName: "",
    headerStatus: "",
    transactionCodeType: "",
    qtn_Job_Remarks: "",
    type: "",
    designerName: "",
    revisionUpdatedDate: getTodaysData() || "",
    // revision: "R0",
    version: "V0",
  });

  useEffect(() => {
    if (!getDropdownData) return;
    setFormInputs((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    }));
    if (getDropdownData?.textField === "typeS") {
      setFormInputs((prev) => ({
        ...prev,
        typeS: getDropdownData?.name,
      }));
      if (getDropdownData.textField === "checkerName") {
        setFormInputs((prev) => ({
          ...prev,
          checkerName: getDropdownData.name,
          checkerNameCode: getDropdownData.textCode,
          checkerNameDesc: getDropdownData.textDesc,
        }));
      }
    }
  }, [getDropdownData]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    transactionDate: getTodaysData() || "",
    clientName: "",
    companyName: "",
    location: "",
    validUntil: "",
    tenestinationDate: getTodaysData() || "",
    qtn_Job_RefNr: "",
    salesOfficerName: "",
    headerStatus: "",
    transactionCodeType: "",
    qtn_Job_Remarks: "",
  };

  const typeS = [
    { id: 1, name: "Job", transactionCodeType: "JB" },
    { id: 2, name: "Quotation", transactionCodeType: "QTN" },
  ];
  const checkerName = [
    { id: 1, name: "Sai Ganandeep" },
    { id: 2, name: "Md Zuber" },
    { id: 3, name: "Gulnaz" },
    { id: 4, name: "Sandeep Kumar C" },
    { id: 4, name: "Shakuntahala K" },
  ];

  const [selectedType, setSelectedType] = useState(null);

  // Update quotationRequest when user selects a type
  useEffect(() => {
    if (selectedType) {
      setFormInputs((prev) => ({
        ...prev,
        type: selectedType.name,
        transactionCodeType: selectedType.transactionCodeType,
        headerStatus:
          selectedType.transactionCodeType === "QTN"
            ? "Quotation Created"
            : selectedType.transactionCodeType === "JB"
            ? "Job Created"
            : "",
      }));
    }
  }, [selectedType]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  //handle cancel modal
  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));
    props.onHide();
  };

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value.toUpperCase(),
    }));
  };

  const loadFirstLevelData = async (queryName) => {
    if (documentNumber) {
      let obj = {
        queryName: queryName,
        documentNumber: documentNumber,
      };

      await ItemService.generateCustomerQuery(obj).then((item) => {
        if (item?.status === 200) {
          setFormInputs(item?.data[0]);
          // setPOLineItemsData(item?.data[0]?.items);
        } else {
          setFormInputs([]);
          console.log(`>> Error: Loading ${queryName}`);
        }
      });
    } else {
      // navigate(Constants.PRESALES_INQUIRY_LIST);
    }
  };

  useEffect(() => {
    loadFirstLevelData("Get_JOB_DETAIL");
    // loadFirstLevelData("Get_QUOTATION_DETAIL");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentNumber]);

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };

  // const handleUpdate = async () => {
  //   let currentRevision = formInputs?.version;
  //   let nextRevision = "V" + (parseInt(currentRevision?.replace("V", "")) + 1);

  //   let obj = {
  //     ...formInputs,
  //   };

  //   await ItemService.reviseQuotationOrJob(obj).then(async (item) => {
  //     if (item?.status === 200) {
  //       toast.success(item?.message || "Revision Job Updated successfully", {
  //         duration: 2000,
  //         position: "top-right",
  //       });

  //       setFormInputs((prev) => ({
  //         ...prev,
  //         version: nextRevision,
  //       }));

  //       props.onHide();

  //       await dispatch(
  //         getQtnJobList({
  //           queryName: "Get_JOB_LIST",
  //           module: "",
  //           page: 1,
  //           per_page: 10,
  //         })
  //       );

  //       navigate(CustomerConstants.CUSTOMER_V4_HB_JOB_LIST);
  //     } else {
  //       toast.error(item?.message || "Please try again !!", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }

  //     setDisabled(false);
  //   });
  // };

  //   const handleUpdate = async () => {
  //   // let current = formInputs?.version;
  //   // let number = parseInt(current?.replace(/[^\d]/g, "")) || 0;
  //   // let nextRevision = "V" + (number + 1);
  //   let currentRevision = formInputs?.version || "V0";
  // let numericPart = parseInt(currentRevision.replace("V", "")) || 0;
  // let nextRevision = "V" + (numericPart + 1);

  //     let obj = {
  //       ...formInputs,
  //       documentNumber:documentNumber,
  //           version: nextRevision,
  //     };

  //     setDisabled(true);

  //     try {
  //       const item = await ItemService.reviseQuotationOrJob(obj);

  //       if (item?.status === 200) {
  //         toast.success(item?.message || "Job Updated successfully", {
  //           duration: 2000,
  //           position: "top-right",
  //         });

  //         // Update local state with new version
  //         // setFormInputs((prev) => ({
  //         //   ...prev,
  //         //   version: "V1",
  //         // }));
  //         setFormInputs((prev) => ({
  //           ...prev,
  //           version: nextRevision,
  //         }));

  //         props.onHide();

  //         await dispatch(
  //           getQtnJobList({
  //             queryName: "Get_JOB_LIST",
  //             module: "",
  //             page: 1,
  //             per_page: 10,
  //           })
  //         );

  //         navigate(CustomerConstants.CUSTOMER_V4_HB_JOB_LIST);
  //         setTimeout(() => {
  //   window.location.reload();
  // }, 200);
  //       } else {
  //         toast.error(item?.message || "Please try again !!", {
  //           duration: 4000,
  //           position: "top-right",
  //         });
  //       }
  //     } catch (error) {
  //       toast.error("Something went wrong!", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     } finally {
  //       setDisabled(false);
  //     }
  //   };

  const handleUpdate = async () => {
    let currentRevision = formInputs?.version || "V0";
    let numericValue = parseInt(currentRevision.replace("V", ""));

    // if numericValue is NaN → default to 0
    numericValue = isNaN(numericValue) ? 0 : numericValue;

    let nextRevision = "V" + (numericValue + 1);

    let obj = {
      ...formInputs,
      version: nextRevision,
      documentNumber: documentNumber,
      transactionCodeType: "JB",
    };

    await ItemService.reviseQuotationOrJob(obj).then(async (item) => {
      // console.log("update:", item);
      if (item?.status === 200) {
        toast.success(item?.message || "Revision Job Updated successfully", {
          duration: 2000,
          position: "top-right",
        });

        setFormInputs((prev) => ({
          ...prev,
          version: nextRevision,
        }));

        props.onHide();

        await dispatch(
          getQtnJobList({
            queryName: "Get_JOB_LIST",
            module: "",
            page: 1,
            per_page: 10,
          })
        );

        navigate(CustomerConstants.CUSTOMER_V4_HB_JOB_LIST);
        //       setTimeout(() => {
        //   window.location.reload();
        // }, 200);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }

      setDisabled(false);
    });
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Job Revision Update
          <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage text-sm px-2 py-1">
            {formInputs?.jobReferenceNr}
          </span>
          <span className="bg-table-status bg-table-success-status headerStatusDetailedPage text-sm px-2 py-1 ms-2">
            {formInputs?.version}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">BI</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Basic Information</span>
                  {/* <span className="subHeaderTitle">Inquire Details</span> */}
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Date"
                            name="transactionDate"
                            id="transactionDate"
                            value={formInputs?.transactionDate}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Client Name"
                            name="clientName"
                            id="clientName"
                            value={formInputs?.clientName}
                            onChange={handleInputChanges}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Company Name"
                            name="companyName"
                            id="companyName"
                            value={formInputs?.companyName}
                            onChange={handleInputChanges}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Building name"
                            name="buildingName"
                            id="buildingName"
                            value={formInputs?.buildingName}
                            onChange={handleInputChanges}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Location"
                            placeholder=""
                            name="location"
                            id="location"
                            value={formInputs?.location}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Sales Officer Name"
                            name="salesOfficerName"
                            id="salesOfficerName"
                            value={formInputs?.salesOfficerName}
                            onChange={handleInputChanges}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Type"
                            placeholder=""
                            data={typeS}
                            id="type"
                            iconClassName="dropdownIcon"
                            name="type"
                            code="typeCode"
                            description="name"
                            setValue={formInputs?.type}
                            getvalue={setSelectedType}
                            // required={true}
                            disabled={true}
                          />
                        </Col>
                        {formInputs?.type === "Job" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Job Reference Number"
                                name="jobReferenceNr"
                                id="jobReferenceNr"
                                value={formInputs?.jobReferenceNr}
                                onChange={handleInputChange}
                                disabled={true}
                              />
                            </Col>
                          </>
                        )}
                        {formInputs?.type === "Quotation" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Quotation Reference Number"
                                name="qtnReferenceNr"
                                id="qtnReferenceNr"
                                value={formInputs?.qtnReferenceNr}
                                onChange={handleInputChange}
                              />
                            </Col>
                          </>
                        )}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Estimation Date"
                            name="estimationDate"
                            id="estimationDate"
                            value={formInputs?.estimationDate}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Designer"
                            name="designerName"
                            id="designerName"
                            value={formInputs?.designerName}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Checker Name"
                            placeholder=""
                            data={checkerName}
                            id="checkerName"
                            iconClassName="dropdownIcon"
                            name="checkerName"
                            code="checkerNameCode"
                            description="name"
                            setValue={formInputs?.checkerName}
                            // getvalue={setSelectedType}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Remarks"
                            placeholder=""
                            name="remarks"
                            id="remarks"
                            value={formInputs?.remarks}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Reivison Date"
                            name="revisionUpdatedDate"
                            id="revisionUpdatedDate"
                            value={formInputs?.revisionUpdatedDate}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Version"
                            name="version"
                            id="version"
                            value={formInputs?.version}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Revision Remarks"
                            name="revisionRemarks"
                            id="revisionRemarks"
                            value={formInputs?.revisionRemarks}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <FileUploadComponent
                            id="supportingDoc"
                            name="supportingDoc"
                            label="Supporting Document"
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            required={true}
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.supportingDoc || ""}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          {(formInputs?.supportingDoc && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.supportingDoc)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleUpdate}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureStockData={getFaliureRevisionUpdate}
        />
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
      </Modal.Body>
    </Modal>
  );
});

export default JobReivisonUpdate;
